import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import { RequireAuth } from './auth/RequireAuth';
import { Layout } from './components/Layout';
import { DashboardPage } from './pages/DashboardPage';
import { AgentsListPage } from './pages/AgentsListPage';
import { AgentEditorPage } from './pages/AgentEditorPage';
import { AgentChatPage } from './pages/AgentChatPage';
import { FlowsListPage } from './pages/FlowsListPage';
import { FlowEditorPage } from './pages/FlowEditorPage';
import { KnowledgeBasesPage } from './pages/KnowledgeBasesPage';
import { RunsListPage } from './pages/RunsListPage';
import { RunDetailPage } from './pages/RunDetailPage';
import { BudgetPage } from './pages/BudgetPage';
import { CostsPage } from './pages/CostsPage';
import { ActivitiesPage } from './pages/ActivitiesPage';
import { UsersPage } from './pages/UsersPage';
import { agentStudioPath } from './lib/routes';
import { PermissionBoundary } from './components/PermissionBoundary';
import { AGENT_STUDIO_PERMISSIONS as P } from './lib/permissions';

export function AgentStudioApp() {
  return (
    <AuthProvider>
      <Routes>
        <Route
          element={
            <RequireAuth>
              <PermissionBoundary permission={P.access} fullPage>
                <Layout />
              </PermissionBoundary>
            </RequireAuth>
          }
        >
          <Route index element={<PermissionBoundary permission={P.dashboardView}><DashboardPage /></PermissionBoundary>} />
          <Route path="agents" element={<PermissionBoundary permission={P.agentsView}><AgentsListPage /></PermissionBoundary>} />
          <Route path="agents/:id" element={<PermissionBoundary permission={P.agentsManage}><AgentEditorPage /></PermissionBoundary>} />
          <Route path="agents/:id/chat" element={<PermissionBoundary permission={P.agentsChat}><AgentChatPage /></PermissionBoundary>} />
          <Route path="flows" element={<PermissionBoundary permission={P.flowsView}><FlowsListPage /></PermissionBoundary>} />
          <Route path="flows/:id" element={<PermissionBoundary permission={P.flowsManage}><FlowEditorPage /></PermissionBoundary>} />
          <Route path="templates" element={<Navigate to={agentStudioPath('flows')} replace />} />
          <Route path="knowledge-bases" element={<PermissionBoundary permission={P.knowledgeBasesView}><KnowledgeBasesPage /></PermissionBoundary>} />
          <Route path="budget" element={<PermissionBoundary permission={P.budgetView}><BudgetPage /></PermissionBoundary>} />
          <Route path="users" element={<PermissionBoundary permission={P.usersManage}><UsersPage /></PermissionBoundary>} />
          <Route path="costs" element={<PermissionBoundary permission={P.costsView}><CostsPage /></PermissionBoundary>} />
          <Route path="activities" element={<PermissionBoundary permission={P.activitiesView}><ActivitiesPage /></PermissionBoundary>} />
          <Route path="runs" element={<PermissionBoundary permission={P.runsView}><RunsListPage /></PermissionBoundary>} />
          <Route path="runs/:id" element={<PermissionBoundary permission={P.runsView}><RunDetailPage /></PermissionBoundary>} />
          <Route path="*" element={<Navigate to={agentStudioPath()} replace />} />
        </Route>
      </Routes>
    </AuthProvider>
  );
}

export { AgentStudioApp as App };
